import { useState, useEffect } from 'react';
import RegistrationChildPersonalInfo from './organisms/RegistrationChildPersonalInfo';
import RegistrationChildResidentialInfo from './organisms/RegistrationChildResidentialInfo';
import RegistrationChildSacraments from './organisms/RegistrationChildSacraments';
import RegistrationChildCat from './organisms/RegistrationChildCat';
import ChildIndicatorContainer from './organisms/ChildIndicatorContainer';
// import { Button } from '@mui/material';
import Button from './atoms/Button';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Link, useNavigate } from 'react-router-dom';
import { validateForm, checkFieldInObject } from '../helper';
import MessageBar from './atoms/MessageBar';
import PageHeader from './molecules/PageHeader';
import RegistrationChildNotes from './organisms/RegistrationChildNotes';

const RegisterChild = ({ formData, updateFormData, registeredStudents }) => {
  const navigate = useNavigate();

  const blankChildObject = {
    bc_name: '',
    first_name: '',
    last_name: '',
    gender: '',
    dob: '',
    id_type: '',
    id_number: '',
    address: '',
    address_unit: '',
    address_postal: '',
    baptised: 'no',
    baptism_date: '',
    baptism_church: '',
    baptism_church_ovr: '',
    first_recon_date: '',
    first_recon_church: '',
    first_recon_church_ovr: '',
    holy_comm_date: '',
    holy_comm_church: '',
    holy_comm_church_ovr: '',
    level: '',
    session_time: '',
    preferred_session_time: '',
    transfer_from: '',
    school: '',
    school_level: '',
    mobile: '',
    notes: 'no',
    photo_opt_in: true,
  };

  const initValidationState = {
    bc_name: false,
    first_name: false,
    last_name: false,
    gender: false,
    dob: false,
    id_type: false,
    id_number: false,
    address_postal: false,
    baptism_date: false,
    level: false,
    session_time: false,
    school: false,
    school_level: false,
  };
  const [childObject, setChildObject] = useState(blankChildObject);
  const [validation, setValidation] = useState(initValidationState);
  const [clearDateTrigger, setClearDateTrigger] = useState(0);
  const [studentArray, setStudentArray] = useState([]);
  const [msg, setMsg] = useState('');

  const updateChild = ({ name, value, checked }) => {
    if (name === 'photo_opt_in') {
      setChildObject(prev => {
        return { ...prev, [name]: checked };
      });
    } else {
      setChildObject(prev => {
        return { ...prev, [name]: value };
      });
    }

    if (checkFieldInObject(name, validation)) {
      setValidation(prev => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const addChild = () => {
    if (validateForm(validation, setValidation, childObject)) {
      setMsg('');
      updateFormData('', childObject, 'students');
      setChildObject(blankChildObject);
      setClearDateTrigger(prev => prev + 1);
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setMsg('Please fill in all required fields');
    }
  };

  const gotoDeclaration = () => {
    if (validateForm(validation, setValidation, childObject)) {
      updateFormData('', childObject, 'students');
      navigate('/register/declaration');
    } else {
      window.scrollTo(0, 0);
      setMsg('Please fill in all required fields');
    }
  };

  // Create arrays to pass into ChildIndicatorContainer
  // get students from past registration (if any)
  useEffect(() => {
    setStudentArray([]); // reset everytime this hook is invoked
    if (registeredStudents.length > 0) {
      registeredStudents.forEach(student => {
        setStudentArray(prev => {
          return [...prev, { name: student.name }];
        });
      });
    }
  }, [registeredStudents]);

  // get students from current formData
  useEffect(() => {
    if (formData.students.length > 0) {
      formData.students.forEach(student => {
        setStudentArray(prev => {
          return [...prev, { name: student.bc_name }];
        });
      });
    }
  }, [formData]);

  // DEBUGGING functions
  const debugObjects = () => {
    console.log(childObject);
    console.log(formData);
  };
  const showValidation = () => {
    console.log(validation);
  };

  const test = () => {
    setValidation(prev => ({
      ...prev,
      session_time: false,
    }));
  };

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <ChildIndicatorContainer studentArray={studentArray} />

      <div className='spacer'></div>

      <PageHeader onClick={debugObjects}>Child Information</PageHeader>
      <MessageBar msg={msg} testid='child-error-msg' styles='pb-2' />
      <RegistrationChildPersonalInfo
        childObject={childObject}
        updateChild={updateChild}
        clearDateTrigger={clearDateTrigger}
        validation={validation}
      />
      <div className='midSpacer'></div>
      <div className='text-xl font-bold md:text-2xl'>
        Residential Information
      </div>
      <RegistrationChildResidentialInfo
        childObject={childObject}
        updateChild={updateChild}
        validation={validation}
      />
      <div className='midSpacer'></div>
      <div className='text-xl font-bold md:text-2xl'>Sacraments</div>
      <RegistrationChildSacraments
        childObject={childObject}
        updateChild={updateChild}
        clearDateTrigger={clearDateTrigger}
        validation={validation}
      />
      <div className='midSpacer'></div>
      <div className='text-xl font-bold md:text-2xl'>Catechism Info</div>
      <RegistrationChildCat
        childObject={childObject}
        updateChild={updateChild}
        validation={validation}
      />
      <div className='midSpacer'></div>

      <div className='text-xl font-bold md:text-2xl'>
        Additional Information
      </div>
      <RegistrationChildNotes updateChild={updateChild} />

      <div className='midSpacer'></div>
      <div className='text-right'>
        <Button callback={addChild} testid='add-child-button'>
          Add another child
        </Button>
        &nbsp;
        <Button callback={gotoDeclaration} testid='finalize-button'>
          Finalize Registration
        </Button>
      </div>

      <div className='right'></div>
    </div>
  );
};

export default RegisterChild;
